module.exports = __webpack_public_path__ + "static/img/solutionDetailPic19.bba4058.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic19.jpg
// module id = yuNG
// module chunks = 1